import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../GetProxy.js";
import { handleResponseCode } from "../../utilities/helpers.js";

const cookies = new Cookies();
const proxy = GetProxy();

export const getAllDeptDivsionAndApp = createAsyncThunk(
  "post/getAllDeptDivsionAndApp",
  async () => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/report/api/v1/Filter/getAllDeptDivisionAndApplication`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const getMainFilterApi = createAsyncThunk(
  "get/getMainFilterApi",
  async () => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/report/api/v1/Filter/mainFilterApi`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getCSP = createAsyncThunk("get/getCSP", async () => {
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");
  try {
    const response = await fetch(
      `${proxy}/report/api/v1/Filter/getAllDeptDivisionAndApplication`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        // body: JSON.stringify(payload),
      }
    );
    handleResponseCode(response);
    const data = await response.json();

    return response.ok ? data : Promise.reject(data);
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
});
export const getCSPForAws = createAsyncThunk(
  "post/getCSPForAws",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    const { payload } = props;
    try {
      const response = await fetch(
        `${proxy}/report/api/v1/Filter/appCodes/accountId`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getCSPForAzure = createAsyncThunk(
  "get/getCSPForAzure",
  async () => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/api/v1/CSPForAzureController/getMainFilterForAzureArchitectureCompliance`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

const initialState = {
  DepartmentDivisionloading: false,
  DepartmentDivisionOption: [],
  CSPForAwsDataLoading: false,
  CSPForAzureDataLoading: false,
  CSPDataLoading: false,
  CSPForAwsData: [],
  CSPForAzureData: [],
  CSPData: [],
  mainFilterApiData: [],
  mainFilterApiLoading: false,
  ApplicationOption: [],
  AccountIDOption: [],
  AccountData: [],
  SubscriptionData: [],
  selectedFiltersData: {
    selectedDepartments: [],
    selectedDivisions: [],
    selectedCSV: [],
    selectedApplications: [],
    selectedAccountIDs: [],
    selectedSubscriptionName: [],
  },
  ontabChange: false,
  error: false,
};
export const filterSlice = createSlice({
  name: "filterSlice",
  initialState,

  reducers: {
    resetAllFilter: (state) => {
      state.selectedFiltersData = {
        ...initialState.selectedFiltersData,
      };
    },
    resetFilters: (state, action) => {
      const keysToReset = action.payload.keysToReset;
      keysToReset.forEach((key) => {
        state.selectedFiltersData[key] = [];
      });
    },
    setSelectedFiltersData: (state, action) => {
      state.selectedFiltersData = action.payload;
    },
    setApplicationFilterData: (state, action) => {
      state.ApplicationOption = action.payload;
    },
    setAccountIDFilterData: (state, action) => {
      state.AccountIDOption = action.payload;
    },
    setAccountData: (state, action) => {
      state.AccountData = action.payload;
    },
    setSubscriptionData: (state, action) => {
      state.SubscriptionData = action.payload;
    },
    setOnTabChange: (state, action) => {
      state.ontabChange = action.payload;
    },
    setError: (state, action) => {
      state.error = false;
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(getAllDeptDivsionAndApp.pending, (state, action) => {
        state.DepartmentDivisionloading = true;
        state.error = false;
      })
      .addCase(getAllDeptDivsionAndApp.fulfilled, (state, action) => {
        state.DepartmentDivisionOption = action.payload;
        state.DepartmentDivisionloading = false;
        state.error = false;
      })
      .addCase(getAllDeptDivsionAndApp.rejected, (state, action) => {
        state.DepartmentDivisionloading = false;
        state.error = true;
      })

      .addCase(getMainFilterApi.pending, (state, action) => {
        state.DepartmentDivisionloading = true;
        state.error = false;
      })
      .addCase(getMainFilterApi.fulfilled, (state, action) => {
        state.mainFilterApiData = action.payload;
        state.DepartmentDivisionloading = false;
        state.error = false;
      })
      .addCase(getMainFilterApi.rejected, (state, action) => {
        state.DepartmentDivisionloading = false;
        state.mainFilterApiData = [];
        state.error = true;
      })

      .addCase(getCSPForAws.pending, (state, action) => {
        state.CSPForAwsDataLoading = true;
        state.error = false;
      })
      .addCase(getCSPForAws.fulfilled, (state, action) => {
        state.CSPForAwsData = action.payload;
        state.CSPForAwsDataLoading = false;
        state.error = false;
      })
      .addCase(getCSPForAws.rejected, (state, action) => {
        state.CSPForAwsDataLoading = false;
        state.error = true;
      })

      .addCase(getCSPForAzure.pending, (state, action) => {
        state.CSPForAzureDataLoading = true;
        state.error = false;
      })
      .addCase(getCSPForAzure.fulfilled, (state, action) => {
        state.CSPForAzureData = action.payload;
        state.CSPForAzureDataLoading = false;
        state.error = false;
      })
      .addCase(getCSPForAzure.rejected, (state, action) => {
        state.CSPForAzureDataLoading = false;
        state.error = true;
      })

      .addCase(getCSP.pending, (state, action) => {
        state.CSPDataLoading = true;
        state.error = false;
      })
      .addCase(getCSP.fulfilled, (state, action) => {
        state.CSPData = action.payload;
        state.CSPDataLoading = false;
        state.error = false;
      })
      .addCase(getCSP.rejected, (state, action) => {
        state.CSPDataLoading = false;
        state.error = true;
      });
  },
});

export const { resetAllFilter } = filterSlice.actions;
export const { resetFilters } = filterSlice.actions;
export const {
  setSelectedFiltersData,
  setApplicationFilterData,
  setAccountIDFilterData,
  setAccountData,
  setSubscriptionData,
  setOnTabChange,
  setError,
} = filterSlice.actions;
export default filterSlice.reducer;
